// extracted by mini-css-extract-plugin
export default {"container":"stickyCTA_container__zRrsJ","wrapper":"stickyCTA_wrapper__TsNjW","image":"stickyCTA_image__NPhyU"};